// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Rectangle } from '@shared/commons/Geometry';
import { QuickTableCell } from './QuickTableCell';
import { ColouringModes } from './QuickTableColumn';
import { ThemeManager } from '../../misc/ThemeManager';
// #region
export class QuickTableRow {
    get isDisplayed() {
        return this._isDisplayed;
    }
    set isDisplayed(value) {
        this._isDisplayed = value;
        if (!isNullOrUndefined(this.item)) {
            this.item.isDisplayed = value;
        }
    }
    constructor(item, table) {
        this._isDisplayed = false;
        this.cells = [];
        this.BackColor = null;
        this.ForeColor = null;
        this.isRowInCollapsedGroup = false;
        this.visible = true;
        this.collapsedFIFO = true; // for SuperPosition and its trades (FIFO) #80010
        this.displayRectangle = new Rectangle();
        this.table = table;
        this.item = item;
        if (isNullOrUndefined(table)) {
            return;
        }
        if (isNullOrUndefined(item)) {
            return;
        }
        const cells = this.cells;
        const len = table.columns.length;
        try {
            for (let i = 0; i < len; i++) {
                const cc = new QuickTableCell();
                const data = item.getColumnData(i);
                cc.value = data.Value;
                cc.formattedValue = data.FormattedValue;
                cc.groupByValue = data.GroupByValue || data.FormattedValue; // The context menu action "Group by" is processed using this value, e.g., #114165.
                cc.QuickTableEditingInfo = item.GetQuickTableEditingInfo(i);
                cc.ReadOnly = !cc.QuickTableEditingInfo;
                cc.TooltipKey = item.GetTooltipKey(i);
                cells.push(cc);
                if (this.table.columns[i].ColouringMode !== ColouringModes.None) {
                    this.ColorCells(i, cc.value, null);
                }
            }
            this.id = item.ItemId;
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            console.log('Creare QuickTableRow throw an exception = ' + ex.message);
        }
    }
    Dispose() {
        if (!isNullOrUndefined(this.item)) {
            this.item.Dispose();
        }
    }
    FillRowByItem(item, forceUpdate) {
        const indexes = [];
        for (let i = 0; i < this.cells.length; i++) {
            indexes.push(i);
        }
        forceUpdate = item.isNeedFireUpdate || forceUpdate;
        item.isNeedFireUpdate = false;
        this.FillRowByItemColumnsToUpdate(item, indexes, forceUpdate);
    }
    FillRowByItemColumnsToUpdate(item, columnsToUpdate, forceUpdate) {
        for (let i = 0; i < columnsToUpdate.length; i++) {
            const columnIndex = columnsToUpdate[i];
            if (columnIndex >= this.table.columns.length) {
                continue;
            }
            // TODO
            if (!this.table.columns[i].visible) {
                continue;
            }
            let val;
            const prevVal = this.cells[columnIndex].value;
            let newFormatValue;
            try {
                const value = item.getColumnValue(i);
                // TODO isNAN
                if (prevVal === value && !forceUpdate /* || isNaN(value) */) {
                    continue;
                }
                const data = item.getColumnData(i);
                val = data.Value;
                newFormatValue = data.FormattedValue;
                const cell = this.cells[columnIndex];
                cell.isDirty =
                    newFormatValue !== cell.formattedValue || (item.NoIgnoreForceUpdateMapIndex[i] && forceUpdate);
                cell.formattedValue = newFormatValue;
                cell.value = val;
                cell.groupByValue = data.GroupByValue || data.FormattedValue;
                cell.TooltipKey = item.GetTooltipKey(columnIndex);
                if (this.table.columns[columnIndex].ColouringMode !== ColouringModes.None) {
                    this.ColorCells(columnIndex, val === null ? 0 : val, prevVal === null ? 0 : prevVal);
                }
            }
            catch (e) {
                ErrorInformationStorage.GetException(e);
            }
        }
    }
    ColorCells(columnIndex, value, prevValue) {
        const cell = this.cells[columnIndex];
        if (this.table.columns[columnIndex].ColouringMode === ColouringModes.Signed) {
            cell.ForeColor = QuickTableRow.ColorBySign(this.table.columns[columnIndex].EmptyValue, value);
        }
        else if (this.table.columns[columnIndex].ColouringMode === ColouringModes.Previous) {
            if (!isValidNumber(prevValue) || value === prevValue) {
                return; // https://tp.traderevolution.com/entity/116914
            }
            if (value > prevValue) {
                cell.ForeColor = ThemeManager.colors.positiveColor;
            }
            else if (value < prevValue) {
                cell.ForeColor = ThemeManager.colors.negativeColor;
            }
        }
    }
    static ColorBySign(emptyValue, value) {
        if (!isValidNumber(value) || value == emptyValue) {
            return null;
        }
        if (value > 0) {
            return ThemeManager.colors.positiveColor;
        }
        else if (value < 0) {
            return ThemeManager.colors.negativeColor;
        }
        else {
            return null;
        }
    }
    updateItem(item) {
        this.FillRowByItem(item);
    }
    isVisible() {
        return this.visible && !this.isRowInCollapsedGroup;
    }
}
